import { Context } from "Context";
import { useContext } from "react";
import Image from "components/shared/Image";
import Link from "components/shared/Link";
import Logo from "../Logo";
import Container from "components/shared/Container";
import Profile from "../profile/Profile";
import useCheckMediaQuery from "hooks/useCheckMediaQuery";
import appConfig from "config.json";
import BannerWrapper from "./BannerWrapper";
import BackButton from "../navigation/BackButton";

const mainClass = "syndicated-banner";
const { mobileMediaQuery } = appConfig;

const Banner = () => {
	const {
		config: {
			store,
			banner: {
				image,
				imageLink,
				imageAlt = "",
				logo = false,
				profileLinks = false,
			},
			showBackButton,
		},
	} = useContext(Context);

	const isMobileView = useCheckMediaQuery(mobileMediaQuery);

	const bannerLinkImage = (
		<Link
			className={`${mainClass}__link`}
			href={imageLink}
			target="_blank"
			rel="noreferrer"
		>
			<Image
				image={{
					url: image,
					alt: imageAlt || "Banner Logo",
				}}
				name="banner-logo"
			/>
		</Link>
	);

	const bannerProfile = showBackButton ? null : (
		<section className={`${mainClass}__profile`}>
			<Profile userStatusLinks username baseStyles />
		</section>
	);

	return logo ? (
		<div className={`${mainClass} ${mainClass}--${store}`}>
			<Container direction="row" modifier="banner" store={store} mobileWrapper>
				<BannerWrapper isMobileView={isMobileView}>
					{isMobileView && showBackButton && <BackButton isMobileView />}
					{bannerLinkImage}
					{profileLinks && !isMobileView && bannerProfile}
					<Logo />
					{!isMobileView && showBackButton && <BackButton />}
				</BannerWrapper>
				{profileLinks && isMobileView && bannerProfile}
			</Container>
		</div>
	) : (
		<div className={`${mainClass} ${mainClass}--no-brand-logo`}>
			{bannerLinkImage}
		</div>
	);
};

export default Banner;
